import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useDragDropScreenReducer = () => useSelector((state: ApplicationState) => state.dragDropScreen);
